








import {Component, Vue} from "vue-property-decorator"
import LoginForm from "@/components/auth/AuthStart.vue"
import Navbar from "@/components/Navbar.vue"
import BaseVue from "@/utils/BaseVue"
import Footer from "@/components/Footer.vue"

@Component({components: {Navbar, Footer}})
export default class App extends BaseVue {
    // private created() {
    //     logger.debug("Created:", this.constructor.name)
    // }
    //
    // private mounted() {
    //     logger.debug("Mounted:", this.constructor.name)
    // }
    //
    // private beforeMount() {
    //     logger.debug("BeforeMount:", this.constructor.name)
    // }
    //
    // private destroyed() {
    //     logger.debug("Destroyed:", this.constructor.name)
    // }
    //
    // private beforeUpdate() {
    //     logger.debug("BeforeUpdate:", this.constructor.name)
    // }
    //
    // private updated() {
    //     logger.debug("Updated:", this.constructor.name)
    // }
}
